module.exports = __webpack_public_path__ + "static/media/hp-catalog-vt-sm.5e5a024a.jpeg";